import React from 'react'

function HelpButton({modelId}) {
    return <button 
                    type="button"
                    class="btn btn-link modal-btn float-right"
                    style={{outline: 'none', boxShadow: 'none'}}
                    data-toggle="modal"
                    data-target={`#${modelId}`}>
        <span class="fas fa-question-circle" aria-hidden="true" style={{color: 'black', fontSize: '25px', paddingTop: '10px'}} />
    </button>
}

export default HelpButton